import React from "react";
export const prohibit = () => {
  return (
    <div className="opinion-wrap">
      <h1>信访人在信访过程中，不得有哪些行为？</h1>
      <div className="text-cont">
      根据《信访工作条例》第二十六条规定，信访人在信访过程中应当遵守法律、法规，不得损害国家、社会、集体的利益和其他公民的合法权利，自觉维护社会公共秩序和信访秩序，不得有下列行为：
　　  <br /><br />（1）在机关、单位办公场所周围、公共场所非法聚集，围堵、冲击机关、单位，拦截公务车辆，或者堵塞、阻断交通；
　　  <br /><br />（2）携带危险物品、管制器具；
　　  <br /><br />（3）侮辱、殴打、威胁机关、单位工作人员，非法限制他人人身自由，或者毁坏财物；
　　  <br /><br />（4）在信访接待场所滞留、滋事，或者将生活不能自理的人弃留在信访接待场所；
　　  <br /><br />（5）煽动、串联、胁迫、以财物诱使、幕后操纵他人信访，或者以信访为名借机敛财；
　　  <br /><br />（6）其他扰乱公共秩序、妨害国家和公共安全的行为。
      </div>
      <br />
    </div>
  );
};
